import { render, staticRenderFns } from "./CohortMultiselect.vue?vue&type=template&id=7922f2d4&scoped=true&"
import script from "./CohortMultiselect.vue?vue&type=script&lang=js&"
export * from "./CohortMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./CohortMultiselect.vue?vue&type=style&index=0&id=7922f2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922f2d4",
  null
  
)

export default component.exports